import { COLORS, RADIUS, SHADOWS } from "../../theme";

export const Style = {
  main: (scroll, src, isOne) => ({
    scrollLeft: scroll || 0,
    position: "relative",
    width: {
      xs: isOne ? "100vw" : "calc( 100vw - 80px )",
      sm: "calc( 50% - 20px )",
      md: "calc( 33% - 22px )",
      lg: "calc( 25% - 27px )",
    },
    height: { xs: "500px", sm: "412px" },
    minWidth: "200px",
    background: `url('${src}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    borderRadius: RADIUS.card,
    border: `1px solid rgba(255,255,255,0.08)`,
    display: "flex",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: SHADOWS.card,
    },
  }),

  card: () => ({
    height: { xs: "500px", sm: "412px" },
    background:
      "linear-gradient(180deg, rgba(10,61,44,0.05) 0%, rgba(26,26,26,0.95) 100%)",
    borderRadius: RADIUS.card,
    boxSizing: "border-box",
    width: "100%",
    px: { xs: "10px", sm: "20px" },
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    cursor: "pointer",
  }),
  dateText: (isArabic) => ({
    fontSize: "12px",
    fontFamily: isArabic ? "Cairo, sans-serif" : "Inter",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.55)",
  }),
  cardContent: (isArabic) => ({
    color: COLORS.white,
    px: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: isArabic ? "end" : "start",
    textAlign: isArabic ? "end" : "start",
    gap: "8px",
  }),
  eventName: (isArabic) => ({
    fontFamily: isArabic ? "Cairo, sans-serif" : "'Playfair Display', serif",
    fontSize: "22px",
    fontWeight: 700,
    lineHeight: 1.15,
  }),
  footer: (isArabic) => ({
    width: "100%",
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    mt: "6px",
    gap: "10px",
  }),
  startPeriod: (isArabic) => ({
    color: COLORS.peach,
    fontFamily: isArabic ? "Cairo, sans-serif" : "Inter",
    lineHeight: 1.3,
    fontSize: "14px",
    fontWeight: 800,
    whiteSpace: "nowrap",
  }),
  ctaButton: (isArabic) => ({
    borderRadius: RADIUS.pill,
    background: COLORS.peach,
    py: "8px",
    px: "18px",
    color: COLORS.dark,
    fontFamily: isArabic ? "Cairo, sans-serif" : "Inter",
    lineHeight: 1.3,
    fontSize: "13px",
    fontWeight: 800,
    whiteSpace: "nowrap",
    "&:hover": { background: COLORS.gold },
  }),
  location: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    fontSize: "14px",
    fontFamily: isArabic ? "Cairo, sans-serif" : "Inter",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "#B4B6B6",
  }),
  name: (isArabic) => ({
    fontSize: "13px",
    display: "flex",
    fontFamily: isArabic ? "Cairo, sans-serif" : "Inter",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: COLORS.gold,
  }),
  favouriteIcon: (isArabic) => ({
    position: "absolute",
    top: 10,
    right: isArabic ? "none" : 10,
    left: isArabic ? 10 : "none",
  }),
};
